import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appInstance, appInfo } from 'src/api';

class ModulesAction extends ActionBasic<ModulesState> {

    readonly defaultPage = {
        pageNum: 1,
        pageSize: 12,
    };

    /** 初始化数据 */
    public initData = () => {
        this.getAppCategory();
        this.getAppList();
    }
    /** 获取app类型列表 */
    public getAppCategory = async () => {
        const appData = await appInstance.appCategory(this, {});
        if (!appData.er) {
            this.modulesState.appCategoryList = appData.res.list;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 分页查看
     */
    public setPage = (pageNum: number) => {
        this.modulesState.pageNum = pageNum;
        this.setModulesState(this.modulesState);
        this.getAppList();
    }
    /** 
     * 获取app列表(判断类型 请求不同接口)
     */
    public getAppList = async () => {
        const type = this.modulesState.isOpen;
        if (type === 'myApp') {
            this.getCompanyQuery();
        } else {
            this.getAppListData();
        }
    }
    public onSearch = () =>{
        this.modulesState.pageNum = 1;
        this.setModulesState(this.modulesState);
        this.getAppList();
    }
    /** 
     * 获取app列表
     */
    public getAppListData = async () => {
        const isOpen = this.modulesState.isOpen;
        const param = {
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
            appName: this.modulesState.searchInfo,
            appDescription: this.modulesState.searchInfo,
            isOpen: isOpen === '0' || isOpen === '1' ? isOpen : undefined,
            appCategoryId: this.modulesState.appCategory === 0 ? undefined : this.modulesState.appCategory,
        };
        const appData = await appInfo.appInfoQuery(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res.items;
            this.modulesState.pageNum = appData.res.pageMeta.pageNum;
            this.modulesState.total = appData.res.pageMeta.total;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 获取app列表 我的应用
     */
    public getCompanyQuery = async () => {
        // const isOpen = this.modulesState.isOpen;
        const param = {
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
            appName: this.modulesState.searchInfo,
            appDescription: this.modulesState.searchInfo,
            appCategoryId: this.modulesState.appCategory === 0 ? undefined : this.modulesState.appCategory,
        };
        const appData = await appInstance.companyQuery(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res.items;
            this.modulesState.pageNum = appData.res.pageMeta.pageNum;
            this.modulesState.total = appData.res.pageMeta.total;
            this.setModulesState(this.modulesState);
        }
    }
    /** 
     * 改变选中状态(私有 公开 我的应用)
     */
    public changeIsOpen = (type: string) => {
        if (type !== this.modulesState.isOpen) {
            this.modulesState.pageNum = 1;
            this.modulesState.searchInfo = undefined;
            this.modulesState.isOpen = type;
            this.setModulesState(this.modulesState, () => {
                this.getAppList();
            });     
        }
    }
    /** 双向绑定输入框 */
    public blindSearchData = (e: any) => {
        this.modulesState.searchInfo = e.target.value;
        this.setModulesState(this.modulesState);
    }
    /** 下拉选app类型 */
    public blindAppCategory = (id: number) => {
        this.modulesState.appCategory = id;
        this.modulesState.pageNum = 1;
        this.setModulesState(this.modulesState, () => {
            this.getAppList();
        });
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/Modules.Action.ts